<ng-content select="[remyCta]"></ng-content>
<div #map [id]="mapId" class="finder-map-container" [ngStyle]="{'height': height, 'width': width}"></div>
